import Home from '../pages/Home/Home';
import Race from '../pages/Race/Race';

const BASE_URL = '';

const ROUTES = {
  BASE_URL: BASE_URL,
  HOME: BASE_URL,
  RACE: `${BASE_URL}/race/:raceTitle?_:raceId`,
  MAIN_LAYOUT: `${BASE_URL}/:pageNavigation`,
};

export const REFS = {
  home: 'home',
  map: 'mapa',
  events: 'carreras',
  calendar: 'calendario',
  contact: 'contacto',
};

const homeRoute = () => ({
  path: ROUTES.HOME,
  component: Home,
});

export const mainRoutes = [
  {
    path: ROUTES.RACE,
    component: Race,
  },
  homeRoute(),
];

export default ROUTES;
